import React, { useState } from 'react';
import { X } from 'lucide-react';
import { sendAuditRequest } from '../services/emailService';

const RequestAuditModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    role: '',
    useCase: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side rate limiting / cooldown
    const lastAttempt = localStorage.getItem('last_audit_request_attempt');
    const now = Date.now();
    if (lastAttempt && now - parseInt(lastAttempt) < 60000) { // 1 minute cooldown
      alert('Please wait a moment before sending another request.');
      return;
    }

    setIsSubmitting(true);

    try {
      await sendAuditRequest(formData);
      localStorage.setItem('last_audit_request_attempt', now.toString());
      setIsSuccess(true);
      setTimeout(() => {
        onClose();
        setIsSuccess(false);
        setFormData({ name: '', email: '', company: '', role: '', useCase: '' });
      }, 2000);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to send request. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        {isSuccess ? (
          <div className="modal-success">
            <div className="success-check">✓</div>
            <h3>Request Submitted</h3>
            <p>Our team will contact you within 24 hours</p>
          </div>
        ) : (
          <>
            <h2 className="modal-title">Request AI Audit</h2>
            <p className="modal-subtitle">Let's assess your AI security posture</p>

            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="John Doe"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Work Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="john@company.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">Company *</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Acme Corp"
                />
              </div>

              <div className="form-group">
                <label htmlFor="role">Role *</label>
                <input
                  type="text"
                  id="role"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="CISO, CTO, AI Lead, etc."
                />
              </div>

              <div className="form-group">
                <label htmlFor="useCase">AI Use Case *</label>
                <textarea
                  id="useCase"
                  name="useCase"
                  value={formData.useCase}
                  onChange={handleChange}
                  required
                  className="form-input form-textarea"
                  placeholder="Briefly describe your AI implementation and security concerns..."
                  rows="3"
                />
              </div>

              <button
                type="submit"
                className="btn-primary btn-full"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Request'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default RequestAuditModal;